import { HTMLAttributes } from "react";

export interface SortableTableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  "data-row-key"?: number | string;
  onRowDragStart: (id: number) => void;
  onRowDrop: (targetId: number, sourceId?: number) => void;
  onRowDragEnd?: () => void;
}

// Keep the component type stable: remounting a row during dragstart cancels
// the browser's native drag. Per-table callbacks are supplied by Table.onRow.
export function SortableTableRow({
  onRowDragStart,
  onRowDrop,
  onRowDragEnd,
  ...props
}: SortableTableRowProps) {
  const rowId = Number(props["data-row-key"]);

  return (
    <tr
      {...props}
      draggable
      onDragStart={(event) => {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", String(rowId));
        onRowDragStart(rowId);
      }}
      onDragOver={(event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
      }}
      onDragEnter={(event) => event.preventDefault()}
      onDrop={(event) => {
        event.preventDefault();
        const sourceIdValue = event.dataTransfer.getData("text/plain");
        const sourceId = sourceIdValue ? Number(sourceIdValue) : undefined;
        onRowDrop(rowId, sourceId);
      }}
      onDragEnd={onRowDragEnd}
      style={{ ...props.style, cursor: "grab", userSelect: "none" }}
    />
  );
}
